define(function(require, exports, module) {
    'use strict';
    var _ = require('underscore');
    var $ = require('j');
    var user = require('user');
    var PortletModel = require('modules/portlet/portlet.model');
    var RegistrationGenericView = require('portlets/registration/generic/registration.view');
    var config = require('config');
    var formRulesUtil = require('portlets/registration/util/formRulesUtil');
    var depositLimitsConfig = require('modules/deposit-limits-config/deposit.limits.config.instance');
    var betLimitsConfig = require('modules/bet-limits-config/bet.limits.config.instance');
    var lossLimitsConfig = require('modules/loss-limits-config/loss.limits.config.instance');
    var tcManager = require('managers/tc.manager.instance');

    module.exports = PortletModel.extend({

        defaults: {
            config: {}
        },

        getView: function() {
            return new RegistrationGenericView({ model: this });
        },

        initialize: function() {
            PortletModel.prototype.initialize.apply(this, arguments);

            const country = user.get('countrySetByGeoIp') || user.get('country');
            const currency = this.getCurrency(country);
            const countryObj = _.find(config.get('allowedCountries'), { code: country });

            _.extend(this.get('config'), {
                defaultCountry: country,
                defaultCurrency: currency,
                UNLIMITED_AMOUNT: depositLimitsConfig.UNLIMITED_AMOUNT,
                ...countryObj && { userPhoneCode: countryObj.code }
            });

            const depositLimitsField = this.getDepositLimitsField();

            if (depositLimitsField) {
                depositLimitsConfig.fetchDepositLimits(currency)
                    .done(this.setDepositLimits.bind(this));
            }

            const betLimitsField = this.getBetLimitsField();

            if (betLimitsField) {
                betLimitsConfig.fetchBetLimits(currency, betLimitsField.isCasinoDefault)
                    .done(this.setBetLimits.bind(this));
            }

            const lossLimitsField = this.getLossLimitsField();

            if (lossLimitsField) {
                lossLimitsConfig.fetchLossLimits(currency, true)
                    .done(this.setLossLimits.bind(this));
            }

            tcManager.fetch().done(function(terms) {
                this.set('tcVersion', terms && terms.version);
            }.bind(this));
        },

        subscribe: function() {
            this.listenTo(user, 'change:countrySetByGeoIp', this.userCountryChangeHandler.bind(this));
        },

        parse: function(response) {
            var regConfig = response.config;
            var italianProvinces = regConfig.italianProvinces;
            var formBuilder = regConfig.regBuilderForm = this._selectRegBuilderForm(regConfig);

            if (formBuilder) {
                var fields = formBuilder.formFields || formBuilder.formElements;
                var genericSteps = this._getGenericSteps(fields);
                var genericRules = this._getGenericRules(formBuilder.formRules);
                var hasCustomButtons = this._hasCustomButtons(fields);
                _.extend(regConfig, {
                    genericSteps: genericSteps,
                    genericRules: genericRules,
                    hasCustomButtons: hasCustomButtons,
                    genericColumnCount: genericSteps.length,
                    genericRuleChainLength: formRulesUtil.getMaxRuleChainLength(genericRules),
                    genericEscapedSymbols: this._getEscapedFields(formBuilder.formFields || [])
                });
            }

            _.extend(regConfig, {
                italianRegCountries: this._getItalianCountries(regConfig.italianRegCountries),
                allowedCurrencies: config.get('allowedCurrencies'),
                italianProvinces: _.pick(italianProvinces, _.keys(italianProvinces).sort()),
                allowedCountries: config.get('allowedCountries')
            });

            return response;
        },

        _getEscapedFields: function(genericFields) {
            return genericFields.reduce(function(memo, curr) {
                if (curr.enableEscapeSymbols) {
                    memo[curr.name] = new RegExp(curr.escapeSymbolsRegExp);
                }

                return memo;
            }, {});
        },

        getDepositLimitsField: function() {
            const regBuilder = this.get('config').regBuilderForm;

            return regBuilder && _.findWhere(regBuilder.formFields, { type: 'depositLimits' });
        },

        getBetLimitsField: function() {
            var regBuilder = this.get('config').regBuilderForm;

            const betLimitsFields = regBuilder && _.findWhere(regBuilder.formFields, { type: 'betLimits' });

            if (betLimitsFields && !betLimitsFields.imsFieldAction) {
                betLimitsFields.imsFieldAction = 'betlimitaction';
            }

            return betLimitsFields;
        },

        getLossLimitsField: function() {
            var regBuilder = this.get('config').regBuilderForm;

            return regBuilder && _.findWhere(regBuilder.formFields, { type: 'lossLimits' });
        },

        _selectRegBuilderForm: function(prefs) {
            var COOKIE_REGFORM_PREFIX = '_form_name_';
            var allRegForms = config.get('forms');
            var cookieFormName = prefs.formCookieName;
            var storedFormName = $.cookie(COOKIE_REGFORM_PREFIX + cookieFormName);
            var regForm = prefs.regBuilderForm;
            var activeForm;

            if (storedFormName) {
                activeForm = _.find(allRegForms, function(form) {
                    return form.name === storedFormName;
                });
            }

            if (!activeForm) {
                activeForm = regForm ? JSON.parse(regForm) : null;
            }

            return activeForm;
        },

        _getItalianCountries: function(italianRegCountries) {
            var countries = [];
            var handleCountryDate = function(date) {
                return Date.parse(date.split('.').reverse().join('/'));
            };

            _.each(italianRegCountries, (itRegEntries, italianCode) => {
               _.each(itRegEntries, (country) => {
                   countries.push({
                       ...country,
                       startDate: handleCountryDate(country.startDate),
                       endDate: handleCountryDate(country.endDate),
                       italianCode
                   });
                });
            });

            return _.sortBy(countries, 'regulationName');
        },

        _getGenericSteps: function(elements) {
            return _.filter(elements, 'active')
                .reduce(function(result, field) {
                    var step = _.last(result);
                    field.type === 'separator' ? result.push([]) : step.push(field);
                    return result;
                }, [[]]);
        },

        _getGenericRules: function(rules) {
            return _.filter(rules, 'active');
        },

        userCountryChangeHandler: function() {
            const country = user.get('countrySetByGeoIp') || user.get('country');
            const currency = this.getCurrency(country);
            const countryObj = _.find(config.get('allowedCountries'), { code: country });

            this.set('config', {
                ...this.get('config'),
                defaultCountry: country,
                defaultCurrency: currency,
                ...countryObj && { userPhoneCode: countryObj.code }
            });
        },

        getCurrency: function(countryCode) {
            const allowedCurrencies = config.get('allowedCurrencies');
            const countryCurrencyObj = _.find(config.get('locationJson.items'), { countryCode });

            if (countryCurrencyObj && allowedCurrencies.includes(countryCurrencyObj.currency)) {
                return countryCurrencyObj.currency;
            }

            return config.get('defaultCurrency');
        },

        _hasCustomButtons: function(elements) {
            return _.some(elements, function(el) {
                return el.type === 'button' && el.active;
            });
        },

        setDepositLimits: function(data) {
            var cfg = this.get('config');

            data = this._setAvailablePeriods(data, cfg, 'depositLimits');

            cfg = _.extend({}, cfg, {
                limit: data.limit,
                depositLimits: data.limits,
                depositConfig: data.config
            });

            this.set('config', cfg);
        },

        setBetLimits: function(data) {
            var cfg = this.get('config');

            if (!data.betLimitEnabled) {
                this.set('config', _.extend({}, cfg, { betLimits: data }));

                return;
            }

            data = this._setAvailablePeriods(data, cfg, 'betLimits');
            data.config.limitActions = config.get('betLossLimitActions').betlimitActions
                .split(',')
                .map(val => val.trim())
                .filter(Boolean);

            return this.set('config', _.extend({}, cfg, { betLimits: data }));
        },

        setLossLimits: function(data) {
            var cfg = this.get('config');

            if (!data.lossLimitEnabled) {
                this.set('config', _.extend({}, cfg, { lossLimits: data }));

                return;
            }

            data = this._setAvailablePeriods(data, cfg, 'lossLimits');
            data.config.limitActions = config.get('betLossLimitActions').losslimitActions
                .split(',')
                .map(val => val.trim())
                .filter(Boolean);

            return this.set('config', _.extend({}, cfg, { lossLimits: data }));
        },

        _setAvailablePeriods: function(data, cfg, type) {
            var periods = data.config.availableTimePeriods;
            var availableFromIMS = {
                isDailyEnabled: periods.includes('daily'),
                isWeeklyEnabled: periods.includes('weekly'),
                isMonthlyEnabled: periods.includes('monthly'),
                ...(type === 'betLimits' || type === 'lossLimits') && { isSessionEnabled: periods.includes('session') }
            };

            if (cfg.regBuilderForm) {
                var availableFromCMS = _.pick(
                    _.findWhere(cfg.regBuilderForm.formFields, { type: type }),
                    Object.keys(availableFromIMS));

                data.config.availableTimePeriods = Object.keys(availableFromCMS).reduce(function(result, key) {
                    result[key] = availableFromCMS[key] && availableFromIMS[key];
                    return result;
                }, {});
            } else {
                data.config.availableTimePeriods = availableFromIMS;
            }

            return data;
        }
    });
});
